import { cn } from '@/lib/cn'
import styles from './Spinner.module.css'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** Announced to screen readers; pass null inside a control that already says it. */
  label?: string | null
}

export function Spinner({ size = 'md', className, label = 'Loading' }: SpinnerProps) {
  return (
    <span className={cn(styles.spinner, styles[size], className)} role={label ? 'status' : undefined}>
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle className={styles.track} cx="12" cy="12" r="9" />
        <circle className={styles.head} cx="12" cy="12" r="9" />
      </svg>
      {label ? <span className="visually-hidden">{label}</span> : null}
    </span>
  )
}
